import { Divisor, Skeleton } from '@recruit-robin/robin-theme/web-components';
import { motion } from 'motion/react';
import { useRef } from 'react';

import { cardAnimationVariants, useStyles } from './Card.styles';
import { Header } from './header/Header';

const List = ({ length }: { length: number }) => {
  return Array.from({ length }).map((_, i) => <CardSkeleton key={i} />);
};

export const CardSkeleton = () => {
  const classes = useStyles();
  const lineWidths = useRef(Array.from({ length: 5 }).map(() => Math.random() * 250 + 120));

  return (
    <motion.div
      css={[classes.card, classes.skeleton]}
      initial="initial"
      animate="animate"
      whileInView="inView"
      viewport={{ once: true }}
      variants={cardAnimationVariants}>
      <Header
        title={
          <Header.Title
            profiles={<Skeleton variant="circle" size={30} />}
            name={<Skeleton variant="text" font={(f) => f.heading[1]} width={150} />}
          />
        }
        subtitle={<Skeleton variant="text" font={(f) => f.heading[5]} width={150} />}
        buttons={null}
      />
      <Divisor customCss={classes.divisor} color={(c) => c.neutral.variant[20]} px={0} py={0} />{' '}
      <div css={classes.body}>
        {lineWidths.current.map((width, i) => (
          <Skeleton key={i} variant="text" font={(f) => f.body.short} width={width} />
        ))}
      </div>
    </motion.div>
  );
};

CardSkeleton.List = List;
